import { registerLazyPopupRenderer } from "@/entities/bottom-popup"

registerLazyPopupRenderer("match-type", () => import("../ui/match-type-popup"))
